import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';
import { useState } from 'react';
import LanguageToggle from './LanguageToggle';

export default function Nav() {
  const { t } = useTranslation();
  const { user, license, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-border bg-background/80 backdrop-blur-md">
      <nav className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <span className="font-display text-xl font-bold tracking-tight">EXUSIAI</span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link to="/pricing" className="text-sm text-muted hover:text-foreground transition-colors">
            {t('nav.pricing')}
          </Link>
          <Link to="/faq" className="text-sm text-muted hover:text-foreground transition-colors">
            {t('nav.faq')}
          </Link>
          {user ? (
            <>
              <Link
                to="/dashboard"
                className="text-sm text-muted hover:text-foreground transition-colors"
              >
                {t('nav.dashboard')}
              </Link>
              <button
                onClick={handleLogout}
                className="text-sm text-muted hover:text-foreground transition-colors"
              >
                {t('nav.logout')}
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm text-muted hover:text-foreground transition-colors">
                {t('nav.login')}
              </Link>
              {license === null && (
                <Link
                  to="/register"
                  className="text-sm px-4 py-2 rounded bg-primary hover:bg-primary-hover text-white transition-colors"
                >
                  {t('nav.getAccess')}
                </Link>
              )}
            </>
          )}
          <LanguageToggle />
        </div>

        <div className="md:hidden flex items-center gap-3">
          <LanguageToggle />
          <button
            className="text-muted"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="md:hidden border-t border-border bg-surface px-6 py-4 flex flex-col gap-4">
          <Link to="/pricing" onClick={() => setMenuOpen(false)} className="text-sm text-muted">
            {t('nav.pricing')}
          </Link>
          <Link to="/faq" onClick={() => setMenuOpen(false)} className="text-sm text-muted">
            {t('nav.faq')}
          </Link>
          {user ? (
            <>
              <Link to="/dashboard" onClick={() => setMenuOpen(false)} className="text-sm text-muted">
                {t('nav.dashboard')}
              </Link>
              <button onClick={handleLogout} className="text-sm text-muted text-left">
                {t('nav.logout')}
              </button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setMenuOpen(false)} className="text-sm text-muted">
                {t('nav.login')}
              </Link>
              <Link to="/register" onClick={() => setMenuOpen(false)} className="text-sm text-muted">
                {t('nav.getAccess')}
              </Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
